import { useState } from 'react';

/** doc: docs/decisions/motion.md section 2, List row insert and remove.
 * Keep each departing identity in its old slot until that row's useMotion exit settles.
 * Current rows always keep query order; reappearing identities cancel their own exit.
 */
export function usePresentRows(ids: readonly string[], enabled = true) {
  const [previous, setPrevious] = useState(ids);
  const [retained, setRetained] = useState(ids);
  if (!enabled && retained.length > 0) {
    setPrevious([]);
    setRetained([]);
  } else if (
    enabled &&
    (previous.length !== ids.length || previous.some((id, index) => id !== ids[index]))
  ) {
    const next = [...ids];
    retained.forEach((id, index) => {
      if (!ids.includes(id)) next.splice(Math.min(index, next.length), 0, id);
    });
    setPrevious(ids);
    setRetained(next);
  }
  return {
    ids: retained,
    present: (id: string) => ids.includes(id),
    exited: (id: string) => {
      if (!ids.includes(id)) setRetained((current) => current.filter((item) => item !== id));
    },
  };
}
